module.exports = __webpack_public_path__ + "static/img/lg-watersolution.faff0cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lg-watersolution.jpg
// module id = ReSF
// module chunks = 0